/* Savary · MultiTool (réplica toolsons) — sustituye al JS de EXA, solo actúa dentro de .mt */
(function () {
  var root = document.querySelector('.mt mt-product-info') ? document : null;
  if (!root) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var fmt = (window.mtMoneyFormat || '${{amount}}');
  function money(cents) {
    var v = (cents / 100).toFixed(2), p = v.split('.');
    var withComma = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), withDot = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withComma;
      if (k === 'amount_with_comma_separator') return withDot + ',' + p[1];
      if (k === 'amount_no_decimals_with_comma_separator') return withDot;
      return withComma + '.' + p[1];
    });
  }

  /* ---------- galería ---------- */
  var list = $('.mt .product__media-list'), thumbs = $$('.mt .thumbnail-list__item');
  var slides = list ? $$('.product__media-item', list) : [];
  var cur = 0;
  function go(i, smooth) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i)); cur = i;
    list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    mark(i);
  }
  function mark(i) {
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    $$('.mt .slider-button--prev, .mt .splide__arrow--prev').forEach(function (b) { if (!b.closest('mt-product-lightbox')) b.disabled = i === 0; });
    $$('.mt .slider-button--next, .mt .splide__arrow--next').forEach(function (b) { if (!b.closest('mt-product-lightbox') && !b.closest('mt-splide-component')) b.disabled = i === slides.length - 1; });
    thumbs.forEach(function (t, k) {
      var b = $('button', t); if (b) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
    });
    var tl = $('.mt .thumbnail-list');
    if (tl && thumbs[i]) { var t = thumbs[i]; var l = t.offsetLeft - tl.offsetLeft - (tl.clientWidth - t.clientWidth) / 2; tl.scrollTo({ left: l, behavior: 'smooth' }); }
  }
  thumbs.forEach(function (t, k) { var b = $('button', t); if (b) b.addEventListener('click', function () { go(k); }); });
  $$('.mt .product-media-slider .slider-button--prev, .mt .product-media-slider .splide__arrow--prev').forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
  $$('.mt .product-media-slider .slider-button--next, .mt .product-media-slider .splide__arrow--next').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
  $$('.mt .thumbnail-slider .slider-button--prev').forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
  $$('.mt .thumbnail-slider .slider-button--next').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
  if (list) {
    var st;
    list.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var x = list.scrollLeft, best = 0, bd = 1e9;
        slides.forEach(function (s, k) { var dd = Math.abs(s.offsetLeft - list.offsetLeft - x); if (dd < bd) { bd = dd; best = k; } });
        if (best !== cur) { cur = best; mark(best); }
      }, 80);
    }, { passive: true });
    mark(0);
  }

  /* ---------- lightbox ---------- */
  var lb = $('.mt mt-product-lightbox'), lbSplide = null;
  function openLb(i) {
    if (!lb) return;
    lb.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden';
    var dotsBox = $('.product-lightbox__dots', lb);
    if (!lbSplide && window.Splide) {
      lbSplide = new Splide($('.product-lightbox__splide', lb), { type: 'loop', arrows: false, pagination: false, start: i, speed: 300 });
      lbSplide.on('mounted move', function () {
        if (!dotsBox) return;
        $$('.product-lightbox__dot', dotsBox).forEach(function (d, k) { d.classList.toggle('is-active', k === lbSplide.index); });
      });
      if (dotsBox && !dotsBox.children.length) slides.forEach(function (_, k) {
        var d = document.createElement('button'); d.type = 'button'; d.className = 'product-lightbox__dot'; d.setAttribute('aria-label', 'Image ' + (k + 1));
        d.addEventListener('click', function () { lbSplide.go(k); }); dotsBox.appendChild(d);
      });
      lbSplide.mount();
      var pv = $('.product-lightbox__arrow--prev', lb), nx = $('.product-lightbox__arrow--next', lb);
      if (pv) pv.addEventListener('click', function () { lbSplide.go('<'); });
      if (nx) nx.addEventListener('click', function () { lbSplide.go('>'); });
    } else if (lbSplide) lbSplide.go(i);
  }
  function closeLb() { if (lb) { lb.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; } }
  if (lb) {
    lb.setAttribute('hidden', '');
    $$('.product-lightbox__close, .product-lightbox__backdrop', lb).forEach(function (b) { b.addEventListener('click', closeLb); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
  }
  slides.forEach(function (s, k) { var o = $('.product__modal-opener', s); if (o) { o.style.cursor = 'zoom-in'; o.addEventListener('click', function () { openLb(k); }); } });

  /* ---------- cantidad (1/2/3 kits) y precios ---------- */
  var qb = $('.mt mt-quantity-breaks');
  var base = qb ? +qb.getAttribute('data-base-price') : 0;
  function selQty() { var r = $('.mt mt-quantity-breaks input[name="quantity"]:checked'); return r ? +r.value : 1; }
  function updatePrices() {
    if (!qb) return;
    var r = $('input[name="quantity"]:checked', qb); var lab = r && $('label[for="' + r.id + '"]', qb);
    if (!lab) return;
    var q = +lab.getAttribute('data-quantity'), pct = parseFloat(lab.getAttribute('data-percentage-left') || '1');
    var cmp = +lab.getAttribute('data-base-compare-price') * q, pr = (base - Math.floor(base * Math.round((1 - pct) * 100) / 100)) * q; /* mismo redondeo que Shopify: descuento por unidad truncado al céntimo */
    $$('.mt .product-page-price .price-item--sale, .mt .product-page-price .price__regular .price-item--regular').forEach(function (e) { e.textContent = money(pr); });
    $$('.mt .product-page-price .price__compare-price s').forEach(function (e) { e.textContent = money(cmp); });
    var pc = $('.mt .product-page-price .badge__percentage-saved'); if (pc && cmp) pc.textContent = Math.round((cmp - pr) * 100 / cmp);
  }
  if (qb) { qb.addEventListener('change', updatePrices); updatePrices(); }

  /* ---------- añadir al carrito -> carrito lateral de Savary ---------- */
  var form = document.getElementById('product-form-mt__main');
  var mainBtn = document.getElementById('ProductSubmitButton-mt__main');
  var stickyBtn = document.getElementById('SectionAtcBtn-mt__main');
  function loading(on) {
    [mainBtn, stickyBtn].forEach(function (b) {
      if (!b) return; b.classList.toggle('loading', on); b.setAttribute('aria-disabled', on ? 'true' : 'false');
      var sp = $('.loading-overlay__spinner', b); if (sp) sp.classList.toggle('hidden', !on);
    });
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: +form.querySelector('[name="id"]').value, quantity: selQty() }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','); body.sections_url = window.location.pathname; } catch (_) { }
    }
    loading(true);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var em = $('.mt .product-form__error-message'), w = $('.mt .product-form__error-message-wrapper');
          if (em && w) { em.textContent = res.description || res.message || 'Error'; w.hidden = false; } return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res); if (typeof drawer.open === 'function') drawer.open(mainBtn); return; } catch (_) { }
        }
        window.location.href = '/cart';
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { loading(false); });
  });
  if (stickyBtn && form) stickyBtn.addEventListener('click', function (e) { e.preventDefault(); if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });

  /* ---------- barra fija tras pasar el botón ---------- */
  var sticky = $('.mt mt-sticky-atc');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.style.transform = past ? 'none' : '';
    }).observe(mainBtn);
  }

  /* ---------- fechas de envío ---------- */
  $$('.mt mt-dynamic-dates').forEach(function (dd) {
    var months = (dd.getAttribute('data-month-labels') || '').split(',').map(function (s) { return s.trim(); });
    function add(n) { var x = new Date(); x.setDate(x.getDate() + n); return x; }
    function f(x) { var d = x.getDate(), suf = (d % 10 === 1 && d !== 11) ? 'st' : (d % 10 === 2 && d !== 12) ? 'nd' : (d % 10 === 3 && d !== 13) ? 'rd' : 'th'; return months[x.getMonth()] + ' ' + d + suf; }
    $$('[data-dynamic-date]', dd).forEach(function (p) {
      var t = p.getAttribute('data-text') || '', mn = +p.getAttribute('data-min-days') || 0, mx = +p.getAttribute('data-max-days') || 0;
      p.innerHTML = t.replace('[start_date]', f(add(mn))).replace('[end_date]', f(add(mx)));
    });
  });

  /* ---------- vídeos (cargan y suenan al verse) ---------- */
  $$('.mt mt-internal-video').forEach(function (iv) {
    var v = $('video', iv); if (!v) return;
    function load() {
      if (v.getAttribute('data-mt-loaded')) return; v.setAttribute('data-mt-loaded', '1');
      $$('source', v).forEach(function (s) {
        var src = s.getAttribute('data-src') || s.getAttribute('data-') || '';
        if (s.type === 'application/x-mpegURL') { s.remove(); return; }
        if (src) s.src = src;
      });
      v.load();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) { load(); var p = v.play(); if (p && p.catch) p.catch(function () { }); iv.classList.add('internal-video--playing'); }
          else if (!v.paused) v.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(iv);
    } else load();
    var pb = $('.internal-video__play', iv);
    if (pb) pb.addEventListener('click', function () { load(); v.play(); });
  });

  /* ---------- resultados: contador de porcentaje ---------- */
  $$('.mt mt-results-container').forEach(function (rc) {
    var dur = +rc.getAttribute('data-duration') || 300;
    function run() {
      $$('.results__percentage', rc).forEach(function (el, k) {
        var target = +el.getAttribute('data-percentage') || 0, p = $('p', el), t0 = null;
        setTimeout(function () {
          function step(ts) {
            if (!t0) t0 = ts; var pr = Math.min(1, (ts - t0) / (dur * 3)), val = Math.round(target * pr);
            if (p) p.textContent = val + '%'; el.style.setProperty('--percentage', val + '%');
            if (pr < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, k * 150);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: 0.3 }); io.observe(rc);
    } else run();
  });

  /* ---------- testimonios: carrusel en móvil, rejilla en escritorio ---------- */
  function initSplides() {
    if (!window.Splide) return setTimeout(initSplides, 120);
    $$('.mt mt-splide-component').forEach(function (sc) {
      var el = $('.splide', sc); if (!el || el.classList.contains('is-initialized')) return;
      var g = function (k, d) { var v = sc.getAttribute('data-' + k); return v == null ? d : v; };
      new Splide(el, {
        mediaQuery: 'min', perPage: +g('slides-mobile', 1), perMove: 1, gap: (+g('gap-mobile', 15)) + 'px',
        padding: { left: (+g('side-padding-mobile', 24)) + 'px', right: (+g('side-padding-mobile', 24)) + 'px' }, arrows: true, pagination: true,
        breakpoints: { 750: { destroy: g('destroy-desktop', 'false') === 'true', perPage: +g('slides-desktop', 3), gap: (+g('gap-desktop', 40)) + 'px', padding: 0 } }
      }).mount();
    });
  }
  initSplides();
})();
